import React from 'react';
import PortfolioCard from './BlogCard.jsx';

const PortfolioGallery = ({
  portfolios,
  loading,
  type,
  allowedActions,
  createAllowed = true,
  onCreatePortfolio,
  onEdit,
  onTogglePublished,
  onView,
  onCopy,
  onCopyLink,
  onDelete,
  onRename,
  onSelect,
}) => {
  const cardActions = onSelect && !allowedActions.includes('Select')
    ? [...allowedActions, 'Select']
    : allowedActions;

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (portfolios.length === 0) {
    return (
      <div className="px-3 px-md-0">
        <div className="alert alert-info rounded-3 p-4 text-center">
          <i className="bi bi-info-circle me-2 fs-5"></i>
          <div>
            <h5 className="alert-heading mb-2">No portfolios yet</h5>
            <p className="mb-3">
              {createAllowed
                ? 'Get started by creating your first portfolio!'
                : 'No portfolios are currently available.'}
            </p>
            {createAllowed ? (
              <button
                type="button"
                className="btn btn-info"
                onClick={onCreatePortfolio}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Create Portfolio
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-3 px-md-0">
      <div className="row g-4">
        {portfolios.map((portfolio) => (
          <div key={portfolio.id} className="col-lg-4 col-md-6">
            <PortfolioCard
              portfolio={portfolio}
              type={type}
              allowedActions={cardActions}
              onEdit={onEdit}
              onTogglePublished={onTogglePublished}
              onView={onView}
              onCopy={onCopy}
              onCopyLink={onCopyLink}
              onDelete={onDelete}
              onRename={onRename}
              onSelect={onSelect}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioGallery;
